
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/sales-automation",
      function () {
        return require("private-next-pages/solutions/sales-automation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/sales-automation"])
      });
    }
  